import React from 'react';
import './App.css';
import logo from './logo.svg';

const App: React.FC = () => {
  const testimonials = [
    {
      name: "Sarah J.",
      quote: "QuBits is my go-to social casino! I've had amazing wins and the games are super fun to play!"
    },
    {
      name: "Michael T.",
      quote: "I highly recommend QuBits to anyone looking for a fun sweepstakes casino experience. The cash prizes are real!"
    },
    {
      name: "Jessica L.",
      quote: "The games on QuBits are top-notch and I love the variety. I've already won several cash prizes!"
    }
  ];

  const gameIcons = [
    { name: "Fortune Wheel", image: "fortune-wheel", category: "Popular" },
    { name: "Diamond Rush", image: "diamond-rush", category: "Popular" },
    { name: "Space Gems", image: "space-gems", category: "Featured" },
    { name: "Lucky 7s", image: "lucky-7s", category: "New" },
    { name: "Gold Vault", image: "gold-vault", category: "Popular" },
    { name: "Mystic Forest", image: "mystic-forest", category: "New" },
    { name: "Dragon's Treasure", image: "dragons-treasure", category: "Featured" },
    { name: "Mega Jackpot", image: "mega-jackpot", category: "Popular" },
    { name: "Fruit Frenzy", image: "fruit-frenzy", category: "Classic" },
    { name: "Vegas Lights", image: "vegas-lights", category: "Featured" },
    { name: "Pirate's Bounty", image: "pirates-bounty", category: "New" },
    { name: "Royal Flush", image: "royal-flush", category: "Popular" },
  ];

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-content">
          <div className="logo-container">
            <img src={logo} alt="QuBits Logo" className="logo" />
            <h1>QuBits</h1>
          </div>
          <nav className="main-nav">
            <ul>
              <li><a href="#games">Games</a></li>
              <li><a href="#prizes">Prizes</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="#about">About</a></li>
            </ul>
          </nav>
          <div className="auth-buttons">
            <button className="btn login">Login</button>
            <button className="btn signup">Sign Up</button>
          </div>
        </div>
      </header>
      
      <section className="hero-section">
        <div className="container">
          <h2>Play, Win, Celebrate!</h2>
          <p>QuBits is the premier Sweepstakes Social Casino where players have fun and win amazing cash prizes!</p>
          <div className="hero-buttons">
            <button className="cta-button primary">Sign Up Now</button>
            <button className="cta-button secondary">Login to Play</button>
          </div>
        </div>
        <div className="particles-bg"></div>
      </section>
      
      <section className="partner-banner">
        <div className="container">
          <p>Featuring award-winning games from</p>
          <div className="partner-logo">
            <a href="https://quantum-studio.eventhorizongroup.ai">
              <img src={`${process.env.PUBLIC_URL}/logos/quantumstudio.png`} alt="Quantum Studio" />
              <span>Quantum Studio</span>
            </a>
          </div>
        </div>
      </section>
      
      <section id="games" className="games-section">
        <div className="container">
          <h2>Play the Best Games in the World</h2>
          <p>Sign up or login now to access our premium collection of games</p>
          
          <div className="game-categories">
            <button className="category-btn active">All Games</button>
            <button className="category-btn">Popular</button>
            <button className="category-btn">New</button>
            <button className="category-btn">Featured</button>
            <button className="category-btn">Classic</button>
          </div>
          
          <div className="games-grid">
            {gameIcons.map((game, index) => (
              <div className="game-icon" key={index}>
                <div className="game-img" style={{backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('https://via.placeholder.com/150/${game.category === 'Popular' ? 'FF2E63' : game.category === 'New' ? '08D9D6' : game.category === 'Featured' ? '7209B7' : '252A34'}/FFFFFF?text=${game.name.replace(' ', '+')}')`}}>
                  {game.category === 'New' && <span className="badge new">NEW</span>}
                  {game.category === 'Popular' && <span className="badge popular">HOT</span>}
                </div>
                <h4>{game.name}</h4>
                <div className="game-overlay">
                  <button className="play-btn">Play Now</button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="games-cta">
            <button className="cta-button primary">Sign Up to Play All Games</button>
          </div>
        </div>
      </section>
      
      <section className="quantum-promo">
        <div className="container">
          <div className="promo-content">
            <div className="promo-text">
              <h2>Premium Games by Quantum Studio</h2>
              <p>Our top games are developed by the industry-leading Quantum Studio, known for creating the most immersive and rewarding slot experiences in the market.</p>
              <p>Experience HTML5 games that work flawlessly on mobile web, mobile apps, and desktop platforms.</p>
              <a href="https://quantum-studio.eventhorizongroup.ai" className="quantum-link">Learn more about Quantum Studio</a>
            </div>
            <div className="promo-image">
              <img src={`${process.env.PUBLIC_URL}/logos/quantumstudio.png`} alt="Quantum Studio" />
            </div>
          </div>
        </div>
      </section>
      
      <section id="testimonials" className="testimonials-section">
        <div className="container">
          <h2>What Our Players Say</h2>
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div className="testimonial-card" key={index}>
                <div className="quote">"</div>
                <p>{testimonial.quote}</p>
                <h4>{testimonial.name}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <section id="prizes" className="prizes-section">
        <div className="container">
          <h2>Real Cash Prizes</h2>
          <p>At QuBits, your gameplay can lead to real rewards!</p>
          
          <div className="prize-features">
            <div className="prize-feature">
              <div className="prize-icon win-icon"></div>
              <h3>Win Big</h3>
              <p>Thousands of players have already won cash prizes playing on QuBits!</p>
            </div>
            
            <div className="prize-feature">
              <div className="prize-icon cash-icon"></div>
              <h3>Easy Cashout</h3>
              <p>Our simple cashout process means you get your winnings quickly and securely.</p>
            </div>
            
            <div className="prize-feature">
              <div className="prize-icon bonus-icon"></div>
              <h3>Daily Bonuses</h3>
              <p>Log in daily to receive bonus coins and increase your chances of winning!</p>
            </div>
          </div>
        </div>
      </section>
      
      <section id="about" className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>About QuBits</h2>
              <p>QuBits is a premier Sweepstakes Social Casino where players can enjoy a variety of exciting games and win real cash prizes.</p>
              <p>Our platform offers a safe, fun, and engaging environment for casino enthusiasts. With a wide selection of games, daily bonuses, and amazing prizes, QuBits is quickly becoming the favorite destination for social casino players.</p>
              <p>QuBits is owned by Event Horizon Group, a leader in digital entertainment experiences.</p>
              <a href="https://eventhorizongroup.ai" className="about-link">Learn more about Event Horizon Group</a>
            </div>
            <div className="about-image">
              <img src={`${process.env.PUBLIC_URL}/logos/qubits.png`} alt="QuBits" />
            </div>
          </div>
        </div>
      </section>
      
      <section className="signup-banner">
        <div className="container">
          <h2>Ready to Play the Best Games in the World?</h2>
          <p>Join thousands of players enjoying our premium games collection!</p>
          <div className="signup-buttons">
            <button className="cta-button primary">Sign Up Now</button>
            <button className="cta-button secondary">Login</button>
          </div>
        </div>
      </section>
      
      <footer className="app-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src={logo} alt="QuBits Logo" className="small-logo" />
              <h3>QuBits</h3>
            </div>
            
            <div className="footer-links">
              <div className="footer-links-column">
                <h4>Games</h4>
                <ul>
                  <li><a href="#games">All Games</a></li>
                  <li><a href="#games">Popular Games</a></li>
                  <li><a href="#games">New Releases</a></li>
                </ul>
              </div>
              
              <div className="footer-links-column">
                <h4>Company</h4>
                <ul>
                  <li><a href="#about">About Us</a></li>
                  <li><a href="https://eventhorizongroup.ai">Event Horizon Group</a></li>
                  <li><a href="https://quantum-studio.eventhorizongroup.ai">Quantum Studio</a></li>
                </ul>
              </div>
              
              <div className="footer-links-column">
                <h4>Legal</h4>
                <ul>
                  <li><a href="#">Terms of Service</a></li>
                  <li><a href="#">Privacy Policy</a></li>
                  <li><a href="#">Responsible Gaming</a></li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} QuBits. All rights reserved. A brand of <a href="https://eventhorizongroup.ai">Event Horizon Group</a>.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
